module.exports = __webpack_public_path__ + "team_name.svg?4697993e008a3b8704764c0484d9614d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/team_name.svg
// module id = 22
// module chunks = 0